import { render, staticRenderFns } from "./PenCanvas.vue?vue&type=template&id=82e9fc2a&scoped=true&lang=pug"
import script from "./PenCanvas.vue?vue&type=script&lang=ts"
export * from "./PenCanvas.vue?vue&type=script&lang=ts"
import style0 from "./PenCanvas.vue?vue&type=style&index=0&id=82e9fc2a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82e9fc2a",
  null
  
)

export default component.exports